import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';
import { useTranslation } from 'react-i18next';
import { DetailCheckResult } from 'features/SubmitProjectProposal/pages';
import ReviewForm from 'features/SubmitProjectProposal/components/RegisterResultR09/ReviewForm';
import Layout from 'layout';
import { LayoutProvider } from '../layout/context/layoutcontext';

export default function CreateCheckResultPage() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate(); // Correctly use the hook at the top level
  const tab = searchParams.get('tab') || 0;
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
        }}
      >
        {/* <CreateCheckResult /> */}
        <>
          <TabView
            activeIndex={parseInt(tab, 10)}
            // eslint-disable-next-line no-undef
            onTabChange={(e) => navigate(`.?tab=${e.index}`)}
          >
            <TabPanel header={t('checkResult.tab')} leftIcon="pi pi-file mr-2">
              <DetailCheckResult />
            </TabPanel>
            <TabPanel header={t('r09.tab')} leftIcon="pi pi-list mr-2">
              <ReviewForm />
            </TabPanel>
          </TabView>
          <ScrollTop target="parent" />
        </>
      </Layout>
    </LayoutProvider>
  );
}
